import { IconImage, IconVideo } from 'icons';

const mediaTypeIcons: Record<string, typeof IconImage> = {
  photo: IconImage,
  video: IconVideo,
};

export default mediaTypeIcons;
